import script from "./CheckBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckBox.vue?vue&type=script&setup=true&lang=js"

import "./CheckBox.vue?vue&type=style&index=0&id=5dfb6ed2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dfb6ed2"]])

export default __exports__